import React, { useEffect, useState } from 'react';
import { FaRoute, FaTaxi, FaMapMarkerAlt, FaStar, FaPhoneAlt } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import Testimonials from '../common/Testimonials';
import { Partners, Tycoons } from '../home/Partners';
import { toast } from 'react-toastify';
import { ts, validatePhoneNumber } from '../utils/metaData';

const TaxiServicePage = () => {
    const location = useLocation();
    const { taxiData } = location.state || {};

    const [data, setData] = useState({
        name: "",
        phone: "",
        pickup: "",
        drop: "",
        pickupDate: ""
    })


    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!data.name || !data.phone || !data.drop || !data.pickup || !data.pickupDate) {
            toast.error("All fields are required.");
            return;
        }

        if (!validatePhoneNumber(data.phone)) {
            toast.error("Invalid Phone Number");
            return;
        }

        try {
            const headers = {
                "Content-Type": "application/json",
                "pid": "INVST"
            }

            const body = JSON.stringify({
                meta: {
                    pid: "INVST",
                    appName: "bestcab",
                    ts: ts(),
                    reqAction: "connect",
                    location: "N/A",
                },
                pay: {
                    phone: data.phone,
                    name: data.name,
                    pickup: data.pickup,
                    drop: data.drop,
                    datetime: data.pickupDate
                }
            })
            console.log("body----", body);
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/user/bestcab/connect`, {
                method: "POST",
                body: body,
                headers: headers,
            })
            const res = await response.json()
            if (res.statusCode == '000') {
                toast.success(res.message)
            }
            else {
                toast.error(res.message)
            }
            setData({
                name: "",
                phone: "",
                pickup: "",
                drop: "",
                pickupDate: ""
            })
        } catch (error) {
            toast.error("Something Went Wrong !");
        }
    }



    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);



    return (
        <div className="min-h-screen flex flex-col">
            <div className="h-[100px]"></div>
            <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex-grow">
                <section className="mb-12">
                    <div className="rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl">
                        <img
                            src={taxiData.img}
                            alt={`${taxiData.city} Taxi Service`}
                            className="w-full h-64 sm:h-80 md:h-96 object-cover object-center"
                        />
                    </div>
                </section>

                {/* Main Content */}
                <section className="mb-16">
                    <div className="flex flex-col md:flex-row gap-8">
                        {/* Left Column */}
                        <div className="md:w-2/3">
                            <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
                                Taxi Service in {taxiData.city}
                            </h1>
                            <div className="flex items-center mb-6">
                                <div className="flex text-yellow-400 mr-4">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="w-5 h-5" />
                                    ))}
                                </div>
                                <span className="text-gray-600">4.9 (120 reviews)</span>
                            </div>
                            <p className="text-gray-600 leading-relaxed text-lg mb-8">
                                {taxiData.description}
                            </p>

                            <div className="bg-blue-50 p-6 rounded-lg mb-8">
                                <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                                    <FaTaxi className="text-pink-600 mr-2" />
                                    Why Choose Our Service
                                </h3>
                                <ul className="grid sm:grid-cols-2 gap-4">
                                    <li className="flex items-start">
                                        <span className="text-pink-600 mr-2">✓</span>
                                        <span>24/7 Availability</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-pink-600 mr-2">✓</span>
                                        <span>Competitive Pricing</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-pink-600 mr-2">✓</span>
                                        <span>Professional Drivers</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-pink-600 mr-2">✓</span>
                                        <span>Clean & Comfortable Vehicles</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="md:w-1/3">
                            <div className="bg-white rounded-xl shadow-md p-6 sticky top-6">
                                <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">Quick Booking</h3>
                                <form className="grid grid-cols-1 gap-4">
                                    <div>
                                        <input
                                            type="text"
                                            name="name"
                                            value={data.name}
                                            onChange={handleChange}
                                            placeholder="Your Name"
                                            className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <input
                                            type="text"
                                            name="phone"
                                            value={data.phone}
                                            onChange={handleChange}
                                            placeholder="Phone Number"
                                            className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300"
                                            required
                                        />
                                    </div>

                                    <div className="relative">
                                        <input
                                            type="text"
                                            name="pickup"
                                            value={data.pickup}
                                            onChange={handleChange}
                                            placeholder="Pickup Location"
                                            className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300 pl-10"
                                            required
                                        />
                                        <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                    </div>

                                    <div className="relative">
                                        <input
                                            type="text"
                                            name="drop"
                                            value={data.drop}
                                            onChange={handleChange}
                                            placeholder="Destination"
                                            className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300 pl-10"
                                            required
                                        />
                                        <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                    </div>
                                    <div>
                                        <input

                                            type="datetime-local"
                                            name="pickupDate"
                                            value={data.pickupDate}
                                            onChange={handleChange}
                                            className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300"
                                            required
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="w-full py-3 bg-pink-600 hover:bg-pink-700 text-white text-lg font-semibold rounded-lg shadow-md transition duration-300 flex items-center justify-center"
                                    >
                                        <FaPhoneAlt className="mr-2" />
                                        Confirm Booking
                                    </button>
                                </form>

                                <div className="mt-4 text-center text-sm text-gray-500">
                                    Or call us: <span className="font-semibold">+91-9256810874</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="mb-16">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
                        Popular Routes from {taxiData.city}
                    </h2>
                    <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {taxiData.popularRoutes.map((route, idx) => (
                            <li
                                key={idx}
                                className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                            >
                                <FaRoute className="text-pink-600 mr-3 min-w-[20px]" />
                                <span className="text-gray-700">{route}</span>
                            </li>
                        ))}
                    </ul>
                </section>

                {/* Testimonials */}

            </main>
            <section className="mb-16">
                <Partners />
                <Testimonials />
            </section>
            <div className="h-[100px]"></div>
        </div>
    );
};

export default TaxiServicePage;